import { Select } from 'antd'
import { GetCityWithSection } from 'hooks/returnCityName'
import React, { useEffect } from 'react'

export const ListExecutor = ({props,selectExecutor}) => {
    const {lstExecutor } = props
    useEffect(()=>{
        const {onGetListExecutor} = props
        onGetListExecutor()
    },[])

    const handleChange = (value) => {
      selectExecutor(value)
      };
  return (
    <div>
<Select
  style={{ width: "100%" }}
  allowClear
  showSearch
  placeholder="انتخاب مجری"
  onChange={handleChange}
  filterOption={(input, option) =>
    (option.label || "").toLowerCase().includes(input.toLowerCase())
  }
>
  {lstExecutor?.map(executor => (
    <Select.Option key={executor.id} value={executor.id} label={executor.fullName + "-" + GetCityWithSection(executor.idSection)}>
      <span
        style={{
          color:  !executor.inactive  ? "red" : "green",
        }}
        dangerouslySetInnerHTML={{
                    __html:
                      executor.fullName + "-" +
                      GetCityWithSection(executor.idSection),
                  }}
      >
      </span>
    </Select.Option>
  ))}
</Select>


    </div>
  )
}
